import * as React from 'react';
import { SvgIcon, SvgIconBaseProps } from '../components/SvgIcon/SvgIcon';

export function HotelIcon(props: SvgIconBaseProps): React.JSX.Element {
    return (
        <SvgIcon {...props} viewBox="0 0 24 24">
            <path d="M 8 2 L 8 3 L 4 3 L 4 5 L 5 5 L 5 21 L 19 21 L 19 5 L 20 5 L 20 3 L 16 3 L 16 2 L 8 2 z M 7 5 L 17 5 L 17 19 L 7 19 L 7 5 z M 9 7 L 9 9 L 11 9 L 11 7 L 9 7 z M 13 7 L 13 9 L 15 9 L 15 7 L 13 7 z M 9 11 L 9 13 L 11 13 L 11 11 L 9 11 z M 13 11 L 13 13 L 15 13 L 15 11 L 13 11 z M 9 15 L 9 17 L 11 17 L 11 15 L 9 15 z M 13 15 L 13 17 L 15 17 L 15 15 L 13 15 z" />
        </SvgIcon>
    );
}
